<template src="./SolicitudesRevisadasLista.html"></template>

<script>
// import csvToJson from "convert-csv-to-json";

// import csvToJson from "@/components/Shared/ExportToFile/ExportToJSON"
import papa from "papaparse";
import SolicitudesRevisadasTabla from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudesRevisadasTabla/SolicitudesRevisadasTabla";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import { Breadcrumb, BreadcrumbItem, Button, Dialog } from "element-ui";
import SolicitudRevisadaVer from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudRevisadaVer/SolicitudRevisadaVer";
import ExportToFile from "@/components/Shared/ExportToFile/ExportToFile";
import { utils } from "@/utils";
import { requestRevisionMixin } from "@/api/partidoPolitico/revisionApi";
import { NotifyMixin } from "@/mixins/NotifyMixin";
import { ExportToFileMixin } from "@/mixins/exportToFile";
import moment from "moment-timezone";
import { RouterMixin } from "@/mixins/routerMixin";
import { BrotliMixin } from "@/mixins/BrotliMixin";

export default {
  name: "SolicitudesRevisadasLista",
  components: {
    SolicitudesRevisadasTabla,
    SolicitudRevisadaVer,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    ExportToFile,
  },
  mixins: [
    requestRevisionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    ExportToFileMixin,
    RouterMixin,
    BrotliMixin,
  ],
  data: () => ({
    loading: false,
    errored: false,
    inRoute: false,
    tableData: [],
    fields: [],
    dlgExportToFile: false,
    idAfiliacion: "",
    header: [
      "Solicitudes de Afiliación",
      "Rut",
      "Nombres",
      "Apellido Paterno",
      "Apellido Materno",
      "Fecha Nacimiento",
      "Correo electrónico",
      "Teléfono móvil",
      "Teléfono fijo",
      "Región",
      "Comuna",
      "Domicilio",
      "Fecha de ingreso",
      "Tipo",
      "Estado de la Solicitud",
    ],
    filter: [
      "id",
      "run",
      "nombres",
      "paterno",
      "materno",
      "fechanacimiento",
      "email",
      "telefonomovil",
      "telefonofijo",
      "region",
      "comuna",
      "domicilio",
      "fechacompleta",
      "tipo_afiliacion",
      "estado",
    ],
    disabled: [
      true,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      true,
      false,
    ],
  }),
  computed: {
    fieldsToExport: function () {
      const list = this.header.map((h, i) => ({
        name: h,
        key: this.filter[i],
        disabled: this.disabled[i],
      }));
      this.$log.debug(list);
      return list;
    },
  },
  filters: {
    capitalize: function (value) {
      return utils.capitalize(value);
    },
  },
  beforeMount() {
    if (this.$route.name === "solicitud-revisadas") {
      this.inRoute = true;
    }
  },
  methods: {
    verSolicitud(id) {
      this.$log.debug("table onVerSolicitud", id);

      this.idAfiliacion = id;
      this.navigate({ name: "revisada-id", params: { id: id } });
    },
    exportToFile(querySearch = "", dateFilter = []) {
      this.$log.debug("exportToFile", querySearch, dateFilter);
      this.querySearch = querySearch;
      this.dateFilter = dateFilter;

      this.dlgExportToFile = true;
    },
    closeDlgExport() {
      this.dlgExportToFile = false;
    },
    async exportToExcel(checkList, fields) {
      this.$log.debug("exportToExcel", checkList, fields);
      const listField = this.getListField(checkList, fields);
      const data = await this.listaAfiliacion({ fields: listField });
      if (!this.errored) {
        const date = moment().format("YYYYMMDDhhmmss");
        const filename = `solicitudes-revisadas-${date}`;
        this.exportExcel(data, checkList, fields, filename);
      }
    },
    async exportToPdf(checkList, fields) {
      this.$log.debug("exportToPdf", checkList, fields);
      const listField = this.getListField(checkList, fields);
      const data = await this.listaAfiliacion({ fields: listField });
      if (!this.errored) {
        const date = moment().format("YYYYMMDDhhmmss");
        const filename = `solicitudes-revisadas-${date}`;
        const title = "Solicitud de afiliación revisadas";
        this.exportPdf(data, checkList, fields, filename, title);
      }
    },
    listaAfiliacion(options = {}) {
      const {
        pageAll = true,
        search = this.querySearch,
        dateRange = this.dateFilter,
        fields = [],
        format = "csv",
        compress = true,
      } = options;
      this.loading = true;
      const pagingQuery = {
        pageAll: pageAll,
        search: search,
        dateRange: dateRange,
        fields: fields,
        format: format,
        compress: compress,
      };

      const loading = this.getLoading();

      return this.listaRevision(pagingQuery)
        .then((response) => {
          this.$log.debug("listaRevision", response.data.statusCode);

          if (response.data.statusCode === 200) {
            this.$log.debug(response.data.datos);
            const data = this.decompress(response.data.datos);
            this.$log.debug(data);
            let dataformat = data;
            if (pagingQuery.format === "csv") {
              // dataformat = csvToJson.fieldDelimiter(";").csvStringToJson(data);
              dataformat = papa.parse(data);
            }
            console.log(dataformat);
            const datasource = dataformat.data.map((row) => {
              row.run = utils.rutFilter(row.run);
              return row;
            });
            this.$log.debug(datasource);
            this.errored = false;

            return datasource;
          } else {
            this.errored = true;
            this.showError("Ocurrió un error inesperado al cargar los datos");
          }
          return [];
        })
        .catch((err) => {
          this.$log.fatal(
            "getListaAfiliacionRevision",
            err,
            err.response,
            err.request
          );
          this.errored = true;
          this.showError("Ocurrió un error inesperado al cargar los datos");
        })
        .finally(() => {
          this.loading = false;
          loading.close();
        });
    },
  },
};
</script>
